/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var CountryValidationStatus;

(function (CountryValidationStatus) {
  CountryValidationStatus["FAIL"] = "fail";
  CountryValidationStatus["OUTSTANDING"] = "outstanding";
  CountryValidationStatus["SUCCESS"] = "success";
})(CountryValidationStatus || (CountryValidationStatus = {}));